import React, { Component } from "react";
import Payment from "@material-ui/icons/Payment";
import * as api from "core-module/services/api";
import Button from "common/components/CustomButtons/Button.jsx";
import { withRouter } from "react-router";
import GridItem from "common/components/Grid/GridItem.jsx";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";
import loadContent from "core-module/hoc/loadContent";
import config from "config";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "common/components/Card/Card.jsx";
import BalanceDue from "./BalanceDue";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { TextField } from "@material-ui/core";

const importedStyle = dashboardStyle;
const styles = {
  cardIconTitle: importedStyle.cardIconTitle,
  upgradepromotext: {
    textAlign: "center",
    alignSelf: "center",
    fontWeight: "300",
    color: "red",
    marginLeft: 50,
  },
  text: {
    margin: 20,
    textAlign: "center",
    alignSelf: "center",
  },
  buttonStyle: {
    margin: "20px",
  },
  highlight: {
    color: "green",
  },
  dialogMessage: {
    textAlign: "center",
  },
};

class BalanceDueCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: props.ids.user,
      messageDialogOpen: false,
      dialogMessage: "",
      paymentDialogOpen: false,
      amountToPay: 0,
      amountToPayError: false,
      pastDue: 0,
      current: 0,
      success: null,
      timestamp: null,
      liveDone: null,
      amountPaid: null,
      errorMessage: "",
    };

    this.handlePostEpayment = this.handlePostEpayment.bind(this);
    this.closeMessageDialog = this.closeMessageDialog.bind(this);
    this.openMessageDialog = this.openMessageDialog.bind(this);
    this.closePaymentDialog = this.closePaymentDialog.bind(this);
    this.openPaymentDialog = this.openPaymentDialog.bind(this);
    this.updateStateFromProps = this.updateStateFromProps.bind(this);
    this.setBills = this.setBills.bind(this);
  }

  setBills(pastDue, current) {
    this.setState({ ...this.state, pastDue: pastDue, current: current });
  }

  openMessageDialog() {
    this.setState({ ...this.state, messageDialogOpen: true });
  }

  closeMessageDialog() {
    this.setState({
      ...this.state,
      messageDialogOpen: false,
      dialogMessage: "",
    });
  }

  openPaymentDialog() {
    this.setState({ ...this.state, paymentDialogOpen: true });
  }

  closePaymentDialog() {
    this.setState({ ...this.state, paymentDialogOpen: false });
  }

  async handlePostEpayment() {
    await api
      .post(`user.${this.state.userId}/epayment`, {
        //Changed to Number conversion for decimal values to work
        amount: Number(this.state.amountToPay),
      })
      .then((res) => {
        if (res.error) {
          this.setState({
            ...this.state,
            dialogMessage: res.message,
            messageDialogOpen: true,
          });
          this.closePaymentDialog();
          this.openMessageDialog();
        } else {
          this.setState({
            ...this.state,
            amountPaid: res.amount,
            liveDone: res.live_done,
            timestamp: res.ts,
            success: res.success,
          });
          this.closePaymentDialog();
        }
      });
  }

  componentDidMount() {
    this.updateStateFromProps();
  }

  componentDidUpdate() {
    if (!this.state.messageDialogOpen && !this.state.paymentDialogOpen) {
      this.updateStateFromProps();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      nextState.pastDue !== this.state.pastDue ||
      nextState.current !== this.state.current
    ) {
      return true;
    }
    if (this.state.messageDialogOpen || this.state.paymentDialogOpen) {
      return true;
    }
    var list = nextProps.getList(
      (oGet, id) => {
        if (this.state.timestamp) {
          const currentTs = oGet("ts");
          if (this.state.timestamp < currentTs) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      },
      () => {
        return [false];
      }
    );
    return list.includes(true);
  }

  updateStateFromProps() {
    this.props.getList(
      (oGet, id) => {
        if (this.state.timestamp) {
          const currentAmount = oGet("amount");
          const currentSuccess = oGet("success");
          const live_done = oGet("live_done");
          const currentTs = oGet("ts");
          if (this.state.timestamp < currentTs) {
            this.setState({
              ...this.state,
              liveDone: live_done,
              timestamp: currentTs,
              amountPaid: currentAmount,
              success: currentSuccess,
            });
          }
        } else {
          this.setState({
            ...this.state,
            liveDone: oGet("live_done"),
            timestamp: oGet("ts"),
            amountPaid: oGet("amount"),
            success: oGet("success"),
          });
        }
      },
      () => {
        return null;
      }
    );
  }

  getStatus() {
    if (!this.state.liveDone) {
      return "Pedning";
    } else {
      return this.state.success === "On" ? "Successful" : "Failed";
    }
  }

  validateAmountToPay(value) {
    var regex = new RegExp(/^\-?[0-9]{1,30}\.{0,1}[0-9]{0,2}$/);
    if (regex.test(value)) {
      return false;
    } else {
      return true;
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Payment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>My Balance</h4>
          </CardHeader>
          <CardBody>
            <GridContainer align="center" justify="center">
              <GridItem xs={12}>
                <BalanceDue
                  pastDue={this.state.pastDue}
                  current={this.state.current}
                  setBills={this.setBills}
                  id={this.props.ids}
                />
              </GridItem>
              <GridItem xs={12}>
                {this.state.timestamp && (
                  <p>
                    Last Payment Attempt:{" "}
                    {this.state.amountPaid
                      ? "$" + this.state.amountPaid + " "
                      : ""}{" "}
                    {
                      new Date(this.state.timestamp * 1000)
                        .toString()
                        .split("GMT")[0]
                    }
                  </p>
                )}
                {this.state.success && <p>Status: {this.getStatus()}</p>}
              </GridItem>
              <GridItem xs={12}>
                <Button
                  style={styles.buttonStyle}
                  color="primary"
                  disabled={false}
                  onClick={this.openPaymentDialog}
                >
                  Pay Now
                </Button>
                <Button
                  style={styles.buttonStyle}
                  color="primary"
                  onClick={() => {
                    this.props.history.push(
                      config.MYACCOUNT.APP_PATH + "/user/documents"
                    );
                  }}
                >
                  View Invoices
                </Button>
                <p>
                  *Current Invoice includes your monthly payment as well as any
                  pending amounts that will be due on the first of next month.
                </p>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
        <Dialog open={this.state.messageDialogOpen}>
          <DialogTitle>{this.state.dialogMessage}</DialogTitle>
          <DialogActions>
            <Button onClick={this.closeMessageDialog} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.paymentDialogOpen}>
          <DialogTitle className={classes.dialogMessage}>
            <p>
              Past Due:{" "}
              {this.state.pastDue >= 0
                ? "$" + this.state.pastDue
                : "CR $" + this.state.pastDue * -1 + " (credit)"}
            </p>
            <p>
              Current:{" "}
              {this.state.current >= 0
                ? "$" + this.state.current
                : "CR $" + this.state.current * -1 + " (credit)"}
            </p>
          </DialogTitle>
          <DialogContent>
            <TextField
              label="Payment Amount ($)"
              fullWidth
              variant="filled"
              error={this.state.amountToPayError}
              onChange={(event) => {
                this.setState({
                  ...this.state,
                  amountToPayError: this.validateAmountToPay(
                    event.target.value
                  ),
                  amountToPay: event.target.value,
                });
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handlePostEpayment}
              disabled={this.state.amountToPayError}
              color="primary"
            >
              Pay
            </Button>
            <Button onClick={this.closePaymentDialog} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default withStyles(styles)(
  withRouter(loadContent(`user.session/epayment`, BalanceDueCard, null, true))
);
